const styles = theme => ({
    fileList: {
        position: 'relative',
        background: 'rgba(255,255,255,1)',
        borderRadius: '10px',
        width: '90%',
        // transition: '5s'
        animation: 'slide-up 1s linear',
        padding: '10px 20px',
        boxShadow: '2px 2px 5px rgba(200,200,200,0.6)'
    },
    '@keyframes slide-up': {
        '0%':{opacity: 0, height: '1%'},
        '100%':{opacity:1, height: '100%'}
    },
    fileListTitle: {
        padding: '10px 10px',
        margin: '10px 10px'
    },
    preview: {
        // padding: '10px 10px',
        // margin: '10px 10px',
        flexWrap: 'wrap',
        height: '200px'
    },
    gridList: {
        flexWrap: 'nowrap',
        transform: 'translateZ(0)',
        // height: '170px'
    },
    clearButton: {
        position: 'absolute',
        margin: theme.spacing.unit,
        right: 2*theme.spacing.unit,
        top: theme.spacing.unit,
        zIndex: 5,
        backgroundColor: 'rgba(240,240,240,1)',
        '&:hover':{
            backgroundColor: 'rgba(240,240,240,0.7)'
        }
    },
    deleteButton: {
        zIndex: 5,
        backgroundColor: 'rgba(200,200,200,0.8)',
        padding: '5px 5px',
        margin: '5px 5px',
    },
    previewImage: {
        display: 'block',
        maxHeight: '150px',
        width: 'auto',
        minHeight: '150px',
        height: '150px'
    },
    imageTile: {
        display: 'flex',
        justifyContent: 'center', 
        margin: '2px 2px' ,
        alignItems: 'center',
        height: '160px',
    },
    titleBar: {
        background:
          'linear-gradient(to top, rgba(200,0,0,0.6) 0%, rgba(200,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
    },
});

export default styles;
